<template>
    <div v-show="step === activeStep" class="max-w-3xl mx-auto text-center">
        <div class="row">
            <div class="col w-full">
                <img :src="category.image" alt="">

                <div class="relative w-full h-3 bg-gray-300 my-12">
                    <div class="absolute inset-y-0 bg-primary-500" :style="`width: ${progress}%`"></div>
                </div>
            </div>
        </div>

        <div class="md:flex md:-mx-2">
            <div class="mb-4 md:mb-0 md:flex-1 md:mx-2">
                <button class="btn btn-primary w-full" @click="skip">No thanks</button>
            </div>

            <div class="mb-4 md:mb-0 md:flex-1 md:mx-2">
                <button class="btn btn-primary w-full" @click="like({ category: category.id, score: 1 })">Not bad</button>
            </div>

            <div class="mb-4 md:mb-0 md:flex-1 md:mx-2">
                <button class="btn btn-primary w-full" @click="like({ category: category.id, score: 2 })">Love it!</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuizStep',

    props: {
        step: {
            type: Number,
            required: true,
        },

        activeStep: {
            type: Number,
            required: true,
        },

        totalSteps: {
            type: Number,
            required: true,
        },

        category: {
            type: Object,
            required: true,
        },
    },

    emits: ['like', 'skip'],

    data() {
        return {
            selectedOption: null,
        };
    },

    computed: {
        progress() {
            return this.step / (this.totalSteps + 1) * 100;
        },
    },

    methods: {
        like(data) {
            this.$emit('like', data);
        },

        skip() {
            this.$emit('skip');
        },
    },
};
</script>
